"use client";
import { useSetAtom } from "jotai";
import { createContext, useContext, ReactNode, useEffect, useState, startTransition } from "react";
import OneSignal, { OneSignalDeferredLoadedCallback } from "react-onesignal";
import { oneSignalIDAtom } from "./_store";
interface NotificationProviderProps {
  createNotification: (title: string, body: string) => Notification;
  isNotificationEnabled: boolean;
}

const NotificationContext = createContext<NotificationProviderProps | undefined>(undefined);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [isBrowserNotificationEnabled, setBrowserNotification] = useState(false);
  const setOneSignalID = useSetAtom(oneSignalIDAtom);
  const createNotification = (title: string, body: string) => {
    return new Notification(title, {
      body,
      icon: "/app-icon/appicon128.png",
    });
  };

  useEffect(() => {
    if (typeof window == "undefined") return;

    const IsDisabled =
      typeof process.env.NEXT_PUBLIC_ONESIGNAL_ENABLE == "undefined" ||
      process.env.NEXT_PUBLIC_ONESIGNAL_ENABLE == "false";

    if (IsDisabled) return;

    OneSignal.init({
      appId: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID,
      safari_web_id: process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID_SAFARI,
      // You can add other initialization options here
      // @ts-ignore
      notifyButton: {
        enable: true,
      },
      // serviceWorkerPath: "/onesignal/OneSignalSDKWorker.js"
    }).then(() => {
      console.log(OneSignal.User.onesignalId);
      setOneSignalID(OneSignal.User.onesignalId);
    });
  }, []);
  return (
    <NotificationContext.Provider value={{ createNotification, isNotificationEnabled: isBrowserNotificationEnabled }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  return context;
}
